import actionCreatorFactory from 'typescript-fsa';
import { Estimate, EstimateListType, EstimateSortState } from '../../type/estimate/estimate.type';
import { apiEstimate } from './api/estimate/api-estiamte';
import { apiEstimateMeisai } from './api/meisai/api-estimate-meisai';
import { EstimateMeisai, EstimateMeisaiListType, EstimateMeisaiSideMenu } from '../../type/estimate/estimate-meisai.type';
import { apiEstimateId } from './api/id/api-estiamte-id';
import { ApiEstimatePrintParam } from './api/print/api-estimate-print';
import { User } from '../../type/auth/user.typs';

const ActionCreator = actionCreatorFactory('estimate');

export const EstimateActions = {
  api: {
    estimate: apiEstimate,
    meisai: apiEstimateMeisai,
    id: apiEstimateId,
    print: ActionCreator<ApiEstimatePrintParam>('print/api'),
  },
  setEstimate: ActionCreator<Estimate | null>('set/estimate'),
  setMeisaiSideMenu: ActionCreator<EstimateMeisaiSideMenu | null>('set/meisai/side/menu'),
  setList: ActionCreator<EstimateListType[] | null>('set/list'),
  setMeisai: ActionCreator<EstimateMeisai | null>('set/meisai'),
  setMeisaiList: ActionCreator<EstimateMeisaiListType[]>('set/meisai/list'),
  setSort: ActionCreator<Partial<EstimateSortState> |null>('set/sort'),
  setInitSort: ActionCreator<User>('set/init/sort'),
  setEstimateSearchSort: ActionCreator<Partial<EstimateSortState> |null>('set/estimate/search/sort'),
  setEstimateSearchInitSort: ActionCreator<User>('set/estimate/search/init/sort'),
  setIsInitSort: ActionCreator<boolean>('sort/init'),
  resetState: ActionCreator('reset/state'),
};
